/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { ReactComponent as WarningIcon } from '../../../assets/images/warning_24px.svg';
import { t } from '../../../providers';
import { resetAccount as resetAccountSlice, error as resetAccountError, loading as resetAccountLoading } from '../authenticationSlice';
import AuthContainer from '../components/AuthContainer';
import { SLICE_NAME } from '../constants';
import ConfirmDialog from './components/ConfirmDialog';
import ResetAccount from './components/ForgottenLoginForm';

const ForgottenLoginPage = () => {
    const warningIcon = <WarningIcon />;
    const history = useHistory();
    const dispatch = useDispatch();
    const loading = useSelector(resetAccountLoading);
    const error = useSelector(resetAccountError);
    const resetAccount = useSelector(resetAccountSlice);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [email, setEmail] = useState('');

    useEffect(() => {
        resetAccount && resetAccount.email && setDialogOpen(true);
    }, [resetAccount]);

    const goBack = (event) => {
        event.preventDefault();
        history.push('/login');
    };

    const closeDialog = () => {
        setDialogOpen(false);
        dispatch({ type: `${SLICE_NAME}/auth`, payload: {} });
        history.push('/login');
    };

    const requestReset = (newEmail) => {
        if (newEmail) {
            setEmail(newEmail);
            dispatch({ type: `${SLICE_NAME}/forgotPassword`, payload: newEmail });
        }
    };

    return (
        <AuthContainer preTitle={warningIcon} title={t('i.forgot.my.password')}>
            <ResetAccount goBack={goBack} requestReset={requestReset} loading={loading} error={!!error && error.description} />
            <ConfirmDialog email={email} open={dialogOpen} onAccept={closeDialog} />
        </AuthContainer>
    );
};

export default ForgottenLoginPage;
